/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_PlanInputs */

const fr_admin_subscription_rights_plan = /** @type {(inputs: Admin_Subscription_Rights_PlanInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palier`)
};

/**

* @param {Admin_Subscription_Rights_PlanInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_plan = /** @type {((inputs?: Admin_Subscription_Rights_PlanInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_PlanInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_plan(inputs)
});